import React, { useEffect, useState } from "react";
import { Redirect } from "react-router";
import { toast } from "react-toastify";
import axios from "axios";
import { Card, Row, Col, CardBody, Button, Progress } from "reactstrap";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { TextField } from "@material-ui/core";
import Chip from "@material-ui/core/Chip";
import AccessTimeIcon from "@material-ui/icons/AccessTime";
import { useHistory } from "react-router";
import Spinner from "../../sample/spinner";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogActions from "@material-ui/core/DialogActions";
import CalendarTodayIcon from "@material-ui/icons/Today";
import MaterialComponent from "../LearnerAssesment/MaterialComponent";
import Latex from "../LearnerAssesment/Latex";
import Tooltip from "@material-ui/core/Tooltip";

const StartExam = (props) => {
  //declaration
  const [quizoffid, setquizoffid] = useState(props?.location?.state?.quizoffid);
  const [ObjectiveQuizdata, setObjectiveQuizdata] = useState([]);
  const [SubjectiveQuizdata, setSubjectiveQuizdata] = useState([]);
  const [checkcofflearn, setcheckcofflearn] = useState(false);
  const [courseoffringlearner, setcourseoffringlearner] = useState(
    props?.location?.state?.courseoffringlearner
  );
  const [quesindex, setQuesIndex] = useState(0);
  const [currentQues, setCurrentQues] = useState(null);
  const [loading, setLoading] = useState(true);
  const [optionsel, setOptionsel] = useState("");
  const [selectedFile, setSelectedFile] = useState("");
  const [subAns, setSubAns] = useState("");
  const [imgfilepath, setImageFilePath] = useState("");
  const [lqfs, setLqfs] = useState([]);
  const [seconds, setSeconds] = React.useState(0);
  // let timer = React.useRef(null);
  let history = useHistory();
  const [open, setOpen] = React.useState(false);
  const [progreess, setProgress] = useState(0);
  const toggle = () => setModal(!modal);
  const [modal, setModal] = useState(false);
  const toggle1 = (filepath) => {
    setModal1(!modal1);
    setImageFilePath(filepath);
  };
  const [modal1, setModal1] = useState(false);
  useEffect(() => {
    // console.log("start quiz")
    startQuiz();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const startQuiz = () => {
    let formData = new FormData();
    if (quizoffid === undefined || courseoffringlearner === undefined) {
      toast.error("Something went wrong!!", {
        position: toast.POSITION.BOTTOM_LEFT,
      });
      setcheckcofflearn(true);
      return;
    }
    formData.append("quizoffid", quizoffid);
    formData.append("courseoffringlearner", courseoffringlearner);
    axios
      .post("LearnerQuiz/startQuiz", formData)
      .then((res) => {
        if (res.data.status === "200" || res.data.status === "100") {
          setLqfs(res.data.learnerData);
          if (res.data.examflag === "YES") {
            toast.error(res.data.message, {
              position: toast.POSITION.BOTTOM_LEFT,
            });
            history.push({
              pathname: "/",
            });
          } else {
            setObjectiveQuizdata(res?.data?.objectivelist_ques_list);
            setSubjectiveQuizdata(res?.data?.subjectivelist_ques_list);
            setSeconds(res.data.end_timer);
            // console.log(res.data.objectivelist_ques_list[0].queid);
            // console.log(res.data.subjectivelist_ques_list[0].queid);
            if (res?.data?.objectivelist_ques_list?.length > 0) {
              setCurrentQues(res.data.objectivelist_ques_list[0]);
              setOptionsel(
                res.data.objectivelist_ques_list[0]?.selected_option
              );
            } else {
              setCurrentQues(res.data.subjectivelist_ques_list[0]);
            }
            setLoading(false);
          }
          return res;
        }
        throw res;
      })
      .catch((error) => {
        let msg = "";
        if (error.response) {
          msg = "Something went wrong.";
        } else if (error.request) {
          msg = "Please try again.";
        } else {
          msg = "Un-expected error.";
        }
        toast.error(msg, {
          position: toast.POSITION.BOTTOM_LEFT,
        });
      });
  };
  //set Question
  const getques = (quest, index) => {
    setCurrentQues(quest);
    setQuesIndex(index);
    setOptionsel(quest?.selected_option);
    setSubAns(quest?.anstext);
    // emptysel();
  };
  const onHandleClick = () => {
    window.open('https://ide.eduplusnow.com/compiler/', '_blank');
  };
  const saveQuestion = () => {
    let formData = new FormData();
    formData.append("quizquessub", currentQues.queid);
    formData.append("courseoffringlearner", courseoffringlearner);
    formData.append("lqfs", lqfs.lqfs);
    formData.append("quizoffid", quizoffid);
    // console.log(selectedFile)
    if (currentQues.quetype === "MCQ") {
      if (optionsel === "" || optionsel === null || optionsel === undefined) {
        // console.log("please select option");
        toast.error("Please Select Option", {
          position: toast.POSITION.BOTTOM_LEFT,
        });
        return;
      }
      formData.append("option", optionsel);
    } else {
      if (subAns === "" && (selectedFile === ""|| selectedFile===undefined )) {
        // console.log("please Enter ans or select file");
        toast.error("Please Enter Answere or Select file", {
          position: toast.POSITION.BOTTOM_LEFT,
        });
        return;
      }
      formData.append("subAns", subAns);
      formData.append("selectedFile", selectedFile);
    }
    axios
      .post("LearnerQuiz/saveQuizOption", formData, {
        onUploadProgress: (data) => {
          // console.log(data.loaded);
          // console.log(data.total);
          setProgress(Math.round((100 * data.loaded) / data.total));
        },
      })
      .then((res) => {
        if (res.data.status === "200" || res.data.status === "100") {
          if (res.data.examflag === "YES") {
            endquiz(res.data.message);
            return;
          }

          // emptysel();
          setSelectedFile("");
          setProgress(0);
          setSeconds(res.data.end_timer);
          if (currentQues.quetype === "MCQ") {
            const updateObjList = [...ObjectiveQuizdata];
            updateObjList[quesindex] = res.data.current_ques;
            setObjectiveQuizdata(updateObjList);
            if (quesindex + 1 < ObjectiveQuizdata.length) getObjNext();
            else if (SubjectiveQuizdata.length > 0) {
              setCurrentQues(SubjectiveQuizdata[0]);
              setQuesIndex(0);
              setSubAns(SubjectiveQuizdata[0].anstext);
              setSelectedFile("");
              // emptysel();
            } else {
              setCurrentQues(ObjectiveQuizdata[0]);
              setQuesIndex(0);
              setOptionsel(ObjectiveQuizdata[0]?.selected_option);
            }
          } else {
            const updatesubjList = [...SubjectiveQuizdata];
            updatesubjList[quesindex] = res.data.current_ques;
            setSubjectiveQuizdata(updatesubjList);
            if (quesindex + 1 < SubjectiveQuizdata.length) {
              getSubNext();
            } else if (ObjectiveQuizdata.length > 0) {
              setCurrentQues(ObjectiveQuizdata[0]);
              setQuesIndex(0);
              setOptionsel(ObjectiveQuizdata[0]?.selected_option);
            } else {
              setCurrentQues(SubjectiveQuizdata[0]);
              setQuesIndex(0);
              setSubAns(SubjectiveQuizdata[0].anstext);
            }
          }
          return res;
        }
        throw res;
      })
      .catch((error) => {
        let msg = "";
        if (error.response) {
          msg = "Something went wrong.";
        } else if (error.request) {
          msg = "Please try again.";
        } else {
          msg = "Un-expected error.";
        }
        toast.error(msg, {
          position: toast.POSITION.BOTTOM_LEFT,
        });
      });
  };

  const getObjNext = () => {
    setCurrentQues(ObjectiveQuizdata[quesindex + 1]);
    setQuesIndex(quesindex + 1);
    setOptionsel(ObjectiveQuizdata[quesindex + 1]?.selected_option);
    // emptysel();
  };
  const getSubNext = () => {
    setCurrentQues(SubjectiveQuizdata[quesindex + 1]);
    setQuesIndex(quesindex + 1);
    setSubAns(SubjectiveQuizdata[quesindex + 1].anstext);
    // emptysel();
  };
  const endquiz = (message) => {
    handleClose();
    let formData = new FormData();
    formData.append("lqfs", lqfs.lqfs);
    formData.append("courseoffringlearner", courseoffringlearner);
    formData.append("quizoffid", quizoffid);
    axios
      .post("LearnerQuiz/endQuiz", formData)
      .then((res) => {
        if (res.data.status === "200" || res.data.status === "100") {
          if (res.data.message === "Quiz Ended successfully") {
            toast.success("Quiz Ended successfully!!", {
              position: toast.POSITION.BOTTOM_LEFT,
            });
          } else {
            toast.error(res.data.message, {
              position: toast.POSITION.BOTTOM_LEFT,
            });
          }
          // console.log(res.data.staticlink);
          history.push({
            pathname: res.data.staticlink,
          });
          return res;
        }
        throw res;
      })
      .catch((error) => {
        let msg = "";
        if (error.response) {
          msg = "Something went wrong.";
        } else if (error.request) {
          msg = "Please try again.";
        } else {
          msg = "Un-expected error.";
        }
        toast.error(msg, {
          position: toast.POSITION.BOTTOM_LEFT,
        });
      });
  };

  //end quiz
  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  //timer

  // to Redirect Landing
  if (checkcofflearn) {
    return <Redirect to="/" />;
  }

  return (
    <div>
      {loading ? (
        <Spinner />
      ) : (
        <>
          <div className="container-fluid ">
            <br />
            <Row>
              <Col xs={6} sm={3}>
                <Tooltip title="Start Time" aria-label="Start Time">
                  <Chip
                    icon={<CalendarTodayIcon />}
                    label={lqfs?.starttime}
                    color="primary"
                    variant="outlined"
                  />
                </Tooltip>
              </Col>

              <Col xs={6} sm={2}>
                <Tooltip title="Remaining Time" aria-label="Remaining Time">
                  <Chip 
                    icon={<AccessTimeIcon />}
                    label={
                      <ExamTimer
                        totSeconds={seconds}
                        onEndQuiz={() => {
                          endquiz("Times up");
                        }}
                      />
                    }
                    color="primary"
                    variant="outlined"
                  />
                </Tooltip>
              </Col>
              <Col xs={6} sm={3}>
                <Tooltip title="End Time" aria-label="End Time">
                  <Chip
                    icon={<CalendarTodayIcon />}
                    label={lqfs?.endtime}
                    color="primary"
                    variant="outlined"
                  />
                </Tooltip>
              </Col>
              <Col xs={6} sm={2}>
                <Button
                  onClick={onHandleClick}
                  variant="contained"
                  color="primary"
                >
                  Online Compiler
                </Button>
              </Col>
              <Col sm={2}>
                <Button color="danger" onClick={(e) => handleClickOpen()}>
                  {/* <Button color="danger" onClick={(e) => endquiz("endbtn")}> */}
                  End Quiz
                </Button>{" "}
              </Col>
            </Row>
            <br />
            <Row>
              <Col lg={8}>
                <div class="panel panel-quiz card">
                  <div class="panel-heading">
                    {" "}
                    <Row>
                      <Col sm={4}>
                        {currentQues?.quetype === "MCQ" ? (
                          <b>
                            Question - {quesindex + 1}/
                            {ObjectiveQuizdata.length}
                          </b>
                        ) : (
                          <b>
                            Question - {quesindex + 1}/
                            {SubjectiveQuizdata.length}
                          </b>
                        )}
                      </Col>
                      <Col sm={4}>
                        <b>Question Type - {currentQues?.quetype}</b>
                      </Col>
                      <Col className="float-name" sm={4}>
                        <b>[{currentQues?.marks} Marks] </b>
                      </Col>
                    </Row>
                  </div>
                  <div class="padding-pannel1">
                    <br />
                    <Latex>
                      <b>
                        <span
                          dangerouslySetInnerHTML={{
                            __html: currentQues?.que,
                          }}
                        />{" "}
                      </b>
                    </Latex>
                    {currentQues?.quefile !== null ? (
                      <>
                        {currentQues?.ext !== null &&
                        currentQues?.ext !== "pdf" &&
                        currentQues?.ext !== "json" ? (
                          <img
                            className="op-img-quiz"
                            src={currentQues?.path + currentQues?.quefile}
                            alt="eduplusnow"
                            onClick={(e) =>
                              toggle1(currentQues?.path + currentQues?.quefile)
                            }
                            width="80"
                            height="80"
                          />
                        ) : (
                          <span>
                            Please see Below for Question file If not able to
                            see then{" "}
                            <a
                              href={currentQues?.path + currentQues?.quefile}
                              style={{ display: "inline-flex", color: "blue" }}
                              target="__blank"
                            >
                              click here.
                            </a>{" "}
                          </span>
                        )}
                        {/* <Modal isOpen={modal} toggle={toggle}>
                          <ModalHeader toggle={toggle}>
                            Question Image Preview
                          </ModalHeader>
                          <ModalBody>
                            <img
                              className="imgs-preview"
                              src={currentQues?.path + currentQues?.quefile}
                              alt="eduplusnow"
                            />
                          </ModalBody>
                        </Modal> */}
                        <br />
                      </>
                    ) : (
                      ""
                    )}
                    {currentQues.quetype === "MCQ" ? (
                      <>
                        <b>Options :</b>
                        <Row className="mt-2">
                          {currentQues.options.map((item, index) => (
                            <>
                              {/* //new containe */}
                              {/* {currentQues.selected_option === item.op_id ? (
                              <> */}
                              <Col xs={2} sm={2}>
                                <div className="d-flex">
                                  <span className="opt">{index + 1}</span>
                                  <input
                                    type="radio"
                                    name={currentQues.queid}
                                    ngmodel={currentQues.queid}
                                    checked={
                                      item.op_id === optionsel ? true : false
                                    }
                                    value={item.op_id}
                                    onChange={(e) => setOptionsel(item.op_id)}
                                    className="adjust-widh"
                                  />
                                </div>
                              </Col>
                              {/* </>
                            ) : (
                              <>
                                <input
                                  type="radio"
                                  name={currentQues.queid}
                                  ngmodel={currentQues.queid}
                                  id={currentQues.queid}
                                  value={item.op_id}
                                  onChange={(e) => setOptionsel(item.op_id)}
                                />
                              </>
                            )} */}

                              <Col  xs={10}  sm={10} className="radio-adj">
                                <Latex>
                                  <span
                                    dangerouslySetInnerHTML={{
                                      __html: item.option_value,
                                    }}
                                  />
                                </Latex>
                                <>
                                  {item?.op_file !== null ? (
                                    <img
                                      className="op-img-quiz"
                                      src={currentQues?.path + item?.op_file}
                                      alt="eduplusnow"
                                      width="80"
                                      height="80"
                                      onClick={(e) =>
                                        toggle1(
                                          currentQues?.path + item?.op_file
                                        )
                                      }
                                    />
                                  ) : (
                                    ""
                                  )}
                                </>
                              </Col>
                            </>
                          ))}
                          <Modal isOpen={modal1} toggl={toggle1}>
                            <ModalHeader toggle={toggle1}>
                              Image Preview
                            </ModalHeader>
                            <ModalBody>
                              <img
                                className="imgs-preview"
                                src={imgfilepath}
                                alt="eduplusnow"
                              />
                            </ModalBody>
                          </Modal>
                        </Row>
                      </>
                    ) : (
                      <>
                        <br />
                        <TextField
                          label="Answer"
                          type="text"
                          id={currentQues?.queid}
                          name={currentQues?.queid}
                          multiline
                          value={subAns}
                          style={{ width: "80%" }}
                          onChange={(e) => setSubAns(e.target.value)}
                        />
                        <br />
                        <input
                          id={currentQues?.queid}
                          type="file"
                          name={currentQues?.queid}
                          onChange={(e) => setSelectedFile(e.target.files[0])}
                          style={{ width: "80%" }}
                        />
                        <br />
                        {currentQues?.ansfile !== null ? (
                          <span>
                            Click here to view uploaded answer file{" "}
                            <a
                              href={currentQues?.path + currentQues?.ansfile}
                              style={{ display: "inline-flex", color: "blue" }}
                              target="__blank"
                            >
                              click here.
                            </a>{" "}
                          </span>
                        ) : (
                          ""
                        )}
                      </>
                    )}
                    <Row>
                      <Col sm={3}></Col>
                      <Col sm={3}>
                        <br />
                        <Button
                          color="success"
                          style={{
                            margin: "2px",
                          }}
                          onClick={(e) => saveQuestion()}
                        >
                          {"Save & Next"}
                        </Button>
                        {/* <Button
                          color="warning"
                          style={{
                            margin: "2px",
                          }}
                        >
                          Clear
                        </Button> */}
                      </Col>

                      <Col sm={6}>
                        {currentQues.quetype !== "MCQ" ? (
                          <>
                            {progreess > 0 && progreess < 100 ? (
                              <Progress animated color="" value={progreess}>
                                {progreess}
                              </Progress>
                            ) : progreess === 100 ? (
                              <span style={{ color: "red" }}>
                                {"File Uploading in progress,Please wait"}
                              </span>
                            ) : (
                              ""
                            )}
                          </>
                        ) : (
                          ""
                        )}
                      </Col>
                    </Row>
                    <br />
                    {/* {console.log(currentQues?.quefile+" "+currentQues.quetype)} */}
                    {currentQues?.quefile !== null &&
                    currentQues.quetype !== "MCQ" ? (
                      <>
                        <MaterialComponent
                          contentType={currentQues.queid}
                          contentId={currentQues.queid}
                          materialid={currentQues.queid}
                          materialtype={currentQues?.ext}
                          materialpath={
                            currentQues?.path + currentQues?.quefile
                          }
                        />
                      </>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
              </Col>
              <Col lg={4}>
                <div class="panel panel-quiz question-qiu card">
                  <div class="panel-heading">
                    <b>Question</b>{" "}
                  </div>
                  <div class="padding-pannel12">
                    {ObjectiveQuizdata.length > 0 ? (
                      <>
                        <div className="row">
                          <div className="col-sm-12 ">
                            <b>MCQ Questions : </b>
                          </div>
                        </div>
                        <div className="row">
                          {ObjectiveQuizdata.map((quest, index) => (
                            <>
                              <div
                                className="col-2 col-sm-2"
                                key={quest?.queid}
                              >
                                <Button
                                  color={quest.btn_color}
                                  onClick={(e) => getques(quest, index)}
                                  style={{
                                    margin: "2px",
                                    borderRadius: "20px",
                                  }}
                                >
                                  {index + 1}
                                </Button>
                              </div>
                            </>
                          ))}
                        </div>
                      </>
                    ) : (
                      ""
                    )}
                    {SubjectiveQuizdata.length > 0 ? (
                      <>
                        <div className="row pt-3 ">
                          <div className="col-sm-12 ">
                            <b>Subjective Questions:</b>
                          </div>
                        </div>
                        <div className="row">
                          {SubjectiveQuizdata.map((quest, index) => (
                            <>
                              <div
                                className="col-2 col-sm-2"
                                key={quest?.queid}
                              >
                                <Button
                                  color={quest.btn_color}
                                  onClick={(e) => getques(quest, index)}
                                  style={{
                                    margin: "2px",
                                    borderRadius: "20px",
                                  }}
                                >
                                  {index + 1}
                                </Button>
                              </div>
                            </>
                          ))}
                        </div>
                        <br />
                        <br />
                        <Row>
                          <Col xs={12} lg={2}>
                            <Button variant="contained" color="success">
                              Answered
                            </Button>
                          </Col>
                          <Col  xs={12} lg={3}></Col>
                          <Col xs={12} lg={7}>
                            <Button variant="contained" color="primary">
                              Not Answered
                            </Button>
                          </Col>
                        </Row>
                        <br />
                      </>
                    ) : (
                      ""
                    )}
                    <div class="bottomqiu-left"></div>
                  </div>
                </div>
              </Col>
            </Row>
            <Dialog
              open={open}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
            >
              <DialogTitle id="alert-dialog-title">
                Do you really want to end quiz?
              </DialogTitle>
              <DialogActions>
                <Button
                  onClick={(e) => endquiz("endbtn")}
                  color="success"
                  autoFocus
                >
                  End Exam
                </Button>
                <Button onClick={handleClose} color="danger">
                  Cancel
                </Button>
              </DialogActions>
            </Dialog>
          </div>
        </>
      )}
    </div>
  );
};

export default StartExam;

const MinutesAndSeconds = ({ totalSeconds }) => {
  const [time, setTime] = React.useState({
    hours: "",
    minutes: "",
    seconds: "",
  });

  function pad(d) {
    return d < 10 ? "0" + d.toString() : d.toString();
  }

  React.useEffect(() => {
    var hours = Math.floor(totalSeconds / 3600);
    var minutes = Math.floor((totalSeconds - hours * 3600) / 60);
    var seconds = totalSeconds - hours * 3600 - minutes * 60;
    setTime({
      hours: pad(hours),
      minutes: pad(minutes),
      seconds: pad(seconds),
    });
  }, [totalSeconds]);

  return (
    <>
      {time.hours}:{time.minutes}:{time.seconds}
    </>
  );
};

// function Latex(props) {
//   const node = React.createRef();
//   const renderMath = () => {
//     window.MathJax.Hub.Queue(["Typeset", window.MathJax.Hub, node.current]);
//   };
//   useEffect(() => {
//     renderMath();
//   }, [props.children]);
//   return (
//     <div ref={node} {...props}>
//       {props.children}
//     </div>
//   );
// }

const ExamTimer = ({ onEndQuiz, totSeconds }) => {
  const [seconds, setSeconds] = React.useState(totSeconds);
  let timer = React.useRef(null);

  React.useEffect(() => {
    setSeconds(totSeconds);
  }, [totSeconds]);

  React.useEffect(() => {
    timer.current = setInterval(() => {
      if (seconds === 0) {
        clearInterval(timer.current);
        onEndQuiz("Times Up!!!");
      } else {
        setSeconds((s) => s - 1);
      }
    }, 1000);
    return () => clearInterval(timer.current);
  }, [seconds]); // eslint-disable-line react-hooks/exhaustive-deps
  return <MinutesAndSeconds totalSeconds={seconds} />;
};
